import NarratorImage from '@/components/app/program/NarratorImage';

import { Bio, CopyWrapper, Name, Wrapper } from './styles';
import { NarratorProps } from './types';

const Narrator = ({ program, theme = 'default', imageAlignment = 'center' }: NarratorProps) => {
	return (
		<Wrapper theme={theme}>
			<NarratorImage alignment={imageAlignment} program={program} />
			<CopyWrapper>
				{program?.narrator?.name && <Name>{program?.narrator.name}</Name>}
				{program?.narrator?.short_bio && <Bio>{program?.narrator.short_bio}</Bio>}
			</CopyWrapper>
		</Wrapper>
	);
};

export default Narrator;
